module.exports = __webpack_public_path__ + "img/red-3-oval-open.22f87b2a.svg";